import { Theme } from '@material-ui/core'
import React, { createContext, useContext } from 'react'
import { getMetaValue } from 'utils'

export interface SignUp {
  step?: string
  firstName?: string
  lastName?: string
  email?: string
  contactMe?: boolean
  subdomain?: string
  lawFirmName?: string
  lawFirmRegistrationNumber?: string
  lawFirmVatRegistrationNumber?: string
  lawFirmCountry?: string
  lawFirmAddress?: string
  lawFirmPostalCode?: string
  roleInLawFirm?: string
  lawFirmSize?: string
  practiceArea?: string
  systemLocale?: string
  timeZoneName?: string
  errors?: string
  pricing?: {
    currency: string
    daily: string
    monthly: string
    monthly_long_term: string
  }
}

export const commonStyles = (theme: Theme) => ({
  formPaper: {
    backgroundColor: theme.palette.background.light,
    borderRadius: theme.shape.borderRadius * 3,
    padding: theme.spacing(3)
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-start'
  },
  input: {
    marginBottom: theme.spacing(2)
  },
  submit: {
    flexGrow: 1,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1)
  }
})

export class FetchError extends Error {
  public response: Response

  constructor(response: Response) {
    super(response.statusText)
    this.response = response
  }

  public get isValidationError(): boolean {
    return this.response.status === 422
  }
}

interface RequestInitWithHashBody extends RequestInit {
  bodyHash?: { [k: string]: any }
}

export async function fetchJson<T>(input: RequestInfo, init?: RequestInitWithHashBody | undefined) {
  if (init?.bodyHash) {
    init.bodyHash['authenticity_token'] ??= getMetaValue('csrf-token')
    init.body = JSON.stringify(init.bodyHash)
  }
  const response = await fetch(input, init as RequestInit)
  if (!response.ok) {
    throw new FetchError(response)
  }
  return response.json<T>()
}

export const SignupContext = createContext<{ signUp: SignUp; setSignUp: React.Dispatch<React.SetStateAction<SignUp>> }>({
  setSignUp: () => ({}),
  signUp: {}
})

export const useSignUp = () => useContext(SignupContext)
